module.exports = __webpack_public_path__ + "img/northstar-8.4d7b218e.jpg";